import React from 'react'

import MapViewSVG from '@/images/home/MapView.svg?react'
import defaultLogo from '@/images/scoring_icon.svg'
import { useEventHub } from './EventHubContext'
import { STATIC_MAP_ENABLED, buildStaticMapUrl } from './eventHub.utils'

export default function EventHubSidebarMap({ className = '' }) {
    const { competition, presentation } = useEventHub()

    const logo = competition?.iconLink?.replace(/(\.[^.]+)$/, '-thumbnail$1') || defaultLogo
    const mapUrl = buildStaticMapUrl(presentation?.longitude, presentation?.latitude, logo)
    const addressLine = [presentation?.location, presentation?.country].filter(Boolean).join(', ')

    // Map switched off (STATIC_MAP_ENABLED): keep the address line, never an empty frame.
    if (!STATIC_MAP_ENABLED && !addressLine) return null

    return (
        // Mock `.ev-map` (301×169, radius 10, hairline) and `.ev-addr` (16px lower, 14px on a 1.35 line, 18×24 pin).
        <div className={`flex flex-col gap-4 ${className}`}>
            {mapUrl ? (
                <div className="relative h-42.25 w-full">
                    <img
                        src={mapUrl}
                        alt={addressLine || 'Event location map'}
                        className="h-full w-full rounded-[10px] border border-[#dbdadf] object-cover"
                        loading="lazy"
                    />
                    {logo && (
                        // The static map is centered on (lng,lat), so a dead-centered
                        // overlay lands exactly on the location. Hidden if it fails to load.
                        <img
                            src={logo}
                            alt=""
                            className="absolute left-1/2 top-1/2 size-10 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white object-contain shadow-[0_2px_6px_rgba(0,0,0,0.3)]"
                            onError={(e) => {
                                e.currentTarget.style.display = 'none'
                            }}
                        />
                    )}
                </div>
            ) : STATIC_MAP_ENABLED ? (
                <div className="flex h-42.25 items-center justify-center rounded-[10px] border border-[#dbdadf] bg-[#f5f5f5]">
                    <MapViewSVG className="w-fit h-[24px] text-gray-300" />
                </div>
            ) : null}

            {addressLine && (
                <div className="flex items-start gap-2 text-sm leading-[1.35] text-[#272727]">
                    <MapViewSVG className="h-6 w-[18px] flex-none overflow-visible" />
                    <span>{addressLine}</span>
                </div>
            )}
        </div>
    )
}
